import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PageDocsNoDateContent from './PageDocsNoDateContent';

function PageDocsNoDate(props) {
    const { layout } = props;
    let content;
    if (layout === 'classic') {
        content = (
            <PageDocsNoDateContent layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <div className="row justify-content-center">
                <div className="col-md-12 col-lg-8 col-xl-8">
                    <PageDocsNoDateContent layout={layout} />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

PageDocsNoDate.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PageDocsNoDate.defaultProps = {
    layout: 'classic',
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PageDocsNoDate);
